<template>
  <!--subPage 상단 Navi-->
  <div class="sub_Navi">
    <ul>
      <li><a class="back" @click="closeModal">뒤로</a></li>
      <li>
        <h1>거래소 포지션 조회</h1>
      </li>
      <li class="linkBox">
        <router-link to="/user" class="close">닫기</router-link>
      </li>
    </ul>
  </div>
  <!--//subPage 상단 Navi :End-->

  <div class="subPage_container" :class="{ isModalOpen: clickPosition }">
    <!--연동거래소 리스트-->
    <div class="position_inner">
      <h3>연동 거래소</h3>
      <ul>
        <li>
          <a @click="changePositionState">
            <i class="exc_img"><img src="@/assets/images/exchange/ec_binance.png" /></i>
            <span class="exc_name">Binance</span>
          </a>
        </li>
        <li @click="changePositionState">
          <a>
            <i class="exc_img"><img src="@/assets/images/exchange/ec_upbit.png" /></i>
            <span class="exc_name">Upbit</span>
          </a>
        </li>
        <li @click="changePositionState">
          <a>
            <i class="exc_img"><img src="@/assets/images/exchange/ec_okx.png" /></i>
            <span class="exc_name">Okx</span>
          </a>
        </li>
        <li>
          <p>연동된 거래소가 없습니다.<br />거래소 API 연동을 하세요.</p>
        </li>
      </ul>
    </div>
  </div>
  <!--//subPage_container :End -->
  <!--//subPage :End -->

  <!-- popup message -->
  <div class="popupMessage">
    <span class="messageTxt"></span>
  </div>
  <!-- popup message end -->
  <!-- <PositionList v-if="clickPosition" /> -->
</template>
<script>
// import PositionList from "@/components/modal/PositionList.vue";
import { mapState, mapMutations } from "vuex";

export default {
  name: "SettingPosition",
  components: {
    // PositionList,
  },
  computed: {
    ...mapState("user", ["clickPosition"]),
  },
  methods: {
    ...mapMutations("user", ["changePosition"]),

    changePositionState() {
      this.changePosition({ state: true });
    },
    closeModal() {
      if (this.clickPosition == true) {
        this.changePosition({ state: false });
      } else {
        this.$router.push("/user");
      }
    },
  },
};
</script>

<style scoped>
/* position 페이지만 padding-top 삭제 */
.subPage_container {
  padding: 0;
}
</style>
